
import { SunStatusUpdaterOptions } from './types';

export const DEFAULT_OPTIONS: Required<SunStatusUpdaterOptions> = {
  autoUpdateThresholdMinutes: 30,
  rateLimit: {
    autoUpdateMinutes: 10,
    manualUpdateMinutes: 2
  }
};

export const UPDATE_DELAYS = {
  AUTO_UPDATE: 2000,
  PERIODIC_CHECK: 10 * 60 * 1000 // 10 minutes
};
